import React from "react";

const Sweden = () => {
  return (
    <svg
      fill="none"
      height="15"
      viewBox="0 0 20 15"
      width="20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        height="15"
        id="mask0_305_22197"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "alpha" }}
        width="20"
        x="0"
        y="0"
      >
        <rect fill="white" height="15" width="20" />
      </mask>
      <g mask="url(#mask0_305_22197)">
        <path
          clipRule="evenodd"
          d="M0 0V15H20V0H0Z"
          fill="#3D58DB"
          fillRule="evenodd"
        />
        <mask
          height="15"
          id="mask1_305_22197"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "alpha" }}
          width="20"
          x="0"
          y="0"
        >
          <path
            clipRule="evenodd"
            d="M0 0V15H20V0H0Z"
            fill="white"
            fillRule="evenodd"
          />
        </mask>
        <g mask="url(#mask1_305_22197)">
          <path
            clipRule="evenodd"
            d="M6.25 0H8.75V6.25H20V8.75H8.75V15H6.25V8.75H0V6.25H6.25V0Z"
            fill="#FECA00"
            fillRule="evenodd"
          />
        </g>
      </g>
    </svg>
  );
};

export default Sweden;
